export default "__VITE_ASSET__e8f288fc__"